module.exports = __webpack_public_path__ + "static/media/WEF-norming-Intro-upper.c677bb8b.mp3";